__turbopack_context__.v({
  "dropdown-link": "user-profile-dropdown-item-module-scss-module__ST8h1q__dropdown-link",
});
